// The well-known path where a project proves ownership before Replay QA sends active security probes.
// Keep this shared between project settings, task dispatch, and the probe's fail-closed fallback.
export const DEFAULT_SECURITY_NONCE_PATH = '/.well-known/replay-qa-security-nonce'
